import { t } from "@/mixins/i18nMixin";
import { STORE } from "@/store";
import { Router } from "@uuip/unified-ui-platform";
import { html } from "lit-html";
import style from "./InteractionsBlock.scss";
import { SERVICE } from "@agentx/agentx-services";
const InteractionsBlock = () => {
    return new Router.RouterView.Block({
        template: html `
      <div class="interactions-view">
        <agentx-wc-panel-frame heading="${t("app:interactions.interactions")}">
          <agentx-wc-interactions-tab-widget
            .isDarkMode=${STORE.app.darkMode}
            .isRTDIntialized=${STORE.app.isRTDIntialized}
            .interactionsStore=${STORE.interactions}
            .isActionsColumnEnabled=${SERVICE.featureflag.isInteractionsViewActionsColumnEnabled()}
            @action-button-open-details=${() => {
            STORE.layout.setRouterViewClasses({ expanded: true });
        }}
          ></agentx-wc-interactions-tab-widget>
        </agentx-wc-panel-frame>
      </div>
    `,
        styles: [style]
    });
};
export default InteractionsBlock;
